// On charge les scripts des dépendances partagées

window.bootstrap = require("bootstrap")

// On active les tooltips sur l'ensemble de l'application

new bootstrap.Tooltip(document.body, {
    selector: '[data-bs-toggle="tooltip"]'
});

// On active les popoovers sur l'ensemble de l'application

import Popover from "bootstrap/js/dist/popover";

let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
popoverTriggerList.map((popoverTriggerEl) => {
    popoverTriggerEl.addEventListener('click', (e) => {
        e.preventDefault();
    })
    let opts = {};
    if (popoverTriggerEl.hasAttribute('data-bs-content-id')) {
        opts.content = document.getElementById(popoverTriggerEl.getAttribute('data-bs-content-id')).innerHTML;
        opts.html = true;
    }
    return new Popover(popoverTriggerEl, opts)
})

// Watch page scroll

window.addEventListener('scroll', (e) => {
    let $bodyWrapper = document.querySelector('.body-wrapper');
    if($bodyWrapper)
    {
        if (window.scrollY > 100) {
            $bodyWrapper.classList.add("scrolled");
        } else {
            $bodyWrapper.classList.remove("scrolled");
        }
    }
})

// Composants partagés

import AppAside from "./components/AppAside";
customElements.define("app-aside", AppAside, {extends: 'div'});